import React, { useEffect, useState } from "react";
import { Link } from "../router";
import { api } from "../api";

// Whole days remaining until `accessUntil`, rounded up (see CourseDetailPage
// for the same helper - kept local here to avoid a cross-page import for
// one small function).
function daysLeft(accessUntil) {
  if (!accessUntil) return null;
  const ms = new Date(accessUntil).getTime() - Date.now();
  if (ms <= 0) return 0;
  return Math.ceil(ms / (24 * 60 * 60 * 1000));
}

function formatDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString(undefined, { dateStyle: "medium" });
}

export default function MyCoursesPage() {
  const [courses, setCourses] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get("/api/my/courses")
      .then((d) => setCourses(d.courses))
      .catch((e) => setError(e.message));
  }, []);

  return (
    <div className="page">
      <h1>My learning</h1>
      {error && <div className="alert alert-error">{error}</div>}
      {courses && courses.length === 0 && (
        <p className="muted">
          You haven't enrolled in any courses yet. <Link to="/">Browse courses</Link>.
        </p>
      )}
      <div className="my-course-list">
        {courses &&
          courses.map((course) => (
            <div className="my-course-row" key={course.id}>
              <div className="my-course-info">
                <h3>{course.title}</h3>
                <div className="progress-bar">
                  <div className="progress-bar-fill" style={{ width: `${course.progress.percent}%` }} />
                </div>
                <span className="muted">
                  {course.progress.completedLessons} / {course.progress.totalLessons} lessons complete
                  {course.enrollmentStatus === "past_due" && (
                    <span className="badge badge-warning"> Payment issue - access may be limited</span>
                  )}
                  {course.accessExpired && <span className="badge badge-warning"> Access expired</span>}
                  {!course.accessExpired && course.accessUntil && (
                    <>
                      {" "}
                      &middot; {daysLeft(course.accessUntil)} day{daysLeft(course.accessUntil) === 1 ? "" : "s"} left
                      (expires {new Date(course.accessUntil).toLocaleDateString()})
                    </>
                  )}
                </span>
                {course.enrolledAt && (
                  <div className="muted" style={{ fontSize: 12 }}>
                    Started {formatDate(course.enrolledAt)}
                  </div>
                )}
              </div>
              <div className="my-course-actions">
                {!course.accessExpired && (
                  <Link to={`/learn/${course.slug}`} className="btn btn-secondary btn-sm">
                    {course.progress.percent === 100 ? "Review course" : "Continue"}
                  </Link>
                )}
                {course.certificateCode && (
                  <a
                    className="btn btn-primary btn-sm"
                    href={`/api/certificates/${course.certificateCode}/download`}
                  >
                    Download certificate
                  </a>
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
